import { CodeGenStatus } from '@common/enums';
import { Entity } from '@common/types/Entity';
import { useMemo } from 'react';

import { useProjectCodeGenStatus } from './useProjectCodeGenStatus';

export const useProjectEntityCodeGenStatus = (
  projectId: string,
  enabled: boolean,
  entity: Entity.Pipeline | Entity.Job
) => {
  const { data: projectData, isInitialLoading: isProjectCodeGenStatusLoading } = useProjectCodeGenStatus(
    projectId,
    enabled
  );

  const { entities, inQueueCount, inProgressCount } = useMemo(() => {
    const entities = projectData?.Project?.[entity === Entity.Pipeline ? 'pipelines' : 'jobs'] || [];
    const entitiesInQueue = entities.filter((entity) => entity.codeGenStatus === CodeGenStatus.InQueue) || [];
    const entitiesInProgress = entities.filter((entity) => entity.codeGenStatus === CodeGenStatus.InProgress) || [];

    return {
      entities,
      inQueueCount: entitiesInQueue.length,
      inProgressCount: entitiesInProgress.length
    };
  }, [projectData, entity]);

  let status = CodeGenStatus.Default;

  const isEntityCodeInQueue = inQueueCount > 0;
  const isEntityCodeGenerating = inProgressCount > 0;
  if (isEntityCodeGenerating) {
    status = CodeGenStatus.InProgress;
  } else if (isEntityCodeInQueue) {
    status = CodeGenStatus.InQueue;
  }

  return {
    codeGenStatus: status,
    entities,
    isCodeGenerating: Boolean(isEntityCodeGenerating || isEntityCodeInQueue),
    isStatusLoading: isProjectCodeGenStatusLoading,
    inQueueCount,
    inProgressCount
  };
};
